// helpers
import { bindEvents, getOffsetBounds, multiClassList } from '../../../assets/js/helpers';

// controllers
import AnimationController from '../../../assets/js/controller/animation';
import ResizeController from '../../../assets/js/controller/resize';
import ScrollController from '../../../assets/js/controller/scroll';

// dom selector (prefixed by data-)
const selector = 'image-text-split';

export default class ImageTextSplit {

	constructor(section) {
		this.el = {
			section,
			imageWrappers: section.querySelectorAll(`.${selector}__image-wrapper`),
			imagesWrapper: section.querySelector(`.${selector}__images-wrapper`),
			textWrappers: section.querySelectorAll(`.${selector}__text-wrapper`)
		};

		// class variable groups

		this.controllers = {
			animation: null,
			resize: null,
			scroll: null
		};

		this.coords = {
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			bounds: null
		};

		this.flags = {
			isStuck: false
		};

		this.states = {
			imageIndex: 0
		};

		// class variables

		// bind events to class scope
		this.events = bindEvents(this);

		// engage
		this.init();
	}

	static get selector() {
		return selector;
	}

	// initialize class

	init() {
		this.addEventListeners();
	}

	// event listeners

	addEventListeners() {
		// this.controllers.animation = AnimationController.set({
		// 	update: this.events._onUpdate,
		// 	render: this.events._onRender
		// });

		this.controllers.resize = ResizeController.set({
			update: () => true,
			render: this.events._onWindowResize
		});

		this.controllers.scroll = ScrollController.set({
			update: this.events._onUpdate,
			render: this.events._onRender
		});

		this.measureResize();
	}

	removeEventListeners() {
		AnimationController.clear(this.controllers.animation);
		ResizeController.clear(this.controllers.resize);
	}

	// listener methods

	_onWindowResize() {
		this.measureResize();
	}

	_onUpdate() {
		return true;
	}

	_onRender() {
		const { position } = ScrollController;

		if (this.coords.bounds.top <= position && this.coords.bounds.bottom > position + this.coords.window.height) {
			this.flags.isStuck = true;

			// lock images on screen
			const topPos = position - this.coords.bounds.top;
			this.el.imagesWrapper.style.transform = `translate3d(0, ${topPos}px, 0)`;

		} else {
			// check bottoming
			if (this.coords.bounds.bottom <= position + this.coords.window.height) {
				const bottomPos = this.coords.bounds.height - this.coords.window.height;
				this.el.imagesWrapper.style.transform = `translate3d(0, ${bottomPos}px, 0)`;
			} else {
				this.el.imagesWrapper.style.transform = 'translate3d(0, 0, 0)';
			}

			this.flags.isStuck = false;
		}

		// calculate visible image index

		if (this.el.imageWrappers.length) {
			const scrollSections = this.el.imageWrappers.length;
			const sectionHeight = (this.coords.bounds.height / (scrollSections + 2));
			const scrollDiff = position - (this.coords.bounds.top + sectionHeight);
			const positiveIndex = Math.floor(scrollDiff / sectionHeight) + 1;
			const imageIndex = scrollDiff < 0 ? 0 : Math.min(scrollSections - 1, positiveIndex);

			if (imageIndex !== this.states.imageIndex) {
				const $activeImageWrapper = this.el.section.querySelector(`.${selector}__image-wrapper.is-active`);
				multiClassList(this.el.imageWrappers, 'remove', ['is-active', 'is-last']);
				$activeImageWrapper.classList.add('is-last');

				this.el.imageWrappers[imageIndex].classList.add('is-active');
				this.states.imageIndex = imageIndex;
			}
		}
	}

	// measurements

	measureResize() {
		this.coords.window.width = window.innerWidth;
		this.coords.window.height = window.innerHeight;
		this.coords.bounds = getOffsetBounds(this.el.section);
	}

	// destroy

	destroy() {
		this.removeEventListeners();
		if (this.controllers.animation) AnimationController.clear(this.controllers.animation);
	}

}
